/**
 * @function constructTargetUrl
 *
 * Call this function to get the target URL of the GoodData dashboard.
 * One of the three parameters passed to formpost to GoodData and obtain authentication.
 *
 * @param {string} project - The ID of the GoodData Project
 * @param {string} dashboard - The ID of the GoodData Dashboard
 * @param {boolean?} nochrome - Pass true if you want to disable the header of the GoodData Dashboard
 * @param {overRideUIDrill?} overrideUIDrill - Pass true if you want to disable GoodData's handling of ui.drill events and overrite it with your own
 * @param {overrodeUILink?} overrideUILink - Pass true if you want to disable GoodData's handling of ui.link events and overrite it with your own
 * @param {overrideReportExport?} overrideReportExport - Pass true if you want to disable GoodData's handling of report.export events and overrite it with your own
 *
 * @return {string} - The constructed target URL for the embedded dashboard to be fed to the GoodDataDashboard component,
 * given the parameters you passed in.
 *
 * @example
 *
 *     constructTargetURL("FWJMTODJN23e33DEEDED34wsD", "019204827", true, true, true, true)
 */
// eslint-disable-next-line import/prefer-default-export
export const constructTargetUrl = (
  project: string,
  dashboard: string,
  nochrome?: boolean,
  overrideUIDrill?: boolean,
  overrideUILink?: boolean,
  overrideReportExport?: boolean
) => {
  return `/dashboard.html#workspace=/gdc/projects/${project}&dashboard=/gdc/md/${project}/obj/${dashboard}${
    nochrome && '&nochrome=true'
  }${
    (overrideUIDrill || overrideUILink || overrideReportExport) && '&override='
  }${overrideUIDrill && 'ui.drill,'}${overrideUILink && 'ui.link,'}${
    overrideReportExport && 'report.export'
  }`;
};
